import React from 'react'
import { Layout } from 'antd'
import { Grid } from 'antd'
import homeBack from '../assets/home_back.jpg'

const { Content } = Layout
const { useBreakpoint } = Grid

interface PageLayoutProps {
  children: React.ReactNode
  style?: React.CSSProperties
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, style }) => {
  const screens = useBreakpoint()
  const isMobile = !screens.lg

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content
        style={{
          minHeight: '100vh',
          backgroundColor: '#66b9bf',
          backgroundImage: `url(${homeBack})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: isMobile ? '140% auto' : '100% auto',
          backgroundPosition: isMobile ? '50% 0' : 'center 0',
          position: 'relative',
          ...style
        }}
      >
        {children}
      </Content>
    </Layout>
  )
}

export default PageLayout